<template>
  <div >   <a-drawer
      :title='title'
      :visible="visible"
      v-bind="drawerConfig"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
      class="box"
  >
    <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
      <a-form-model-item
          ref="exchange_mode"
          label="兑换方式"
          prop="exchange_mode"
          :help="formErr.exchange_mode"
          :validateStatus='!formErr.exchange_mode||formErr.exchange_mode==""?"":"error"'
      >
        <a-select v-model="form.exchange_mode"  @change="(e)=>{exchangeMode(e)}">
          <a-select-option :value="item.value" :key="item.value" v-for="item in seleList.exchange_mode"  >
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
          ref="exchange_name"
          label="兑换类型"
          prop="exchange_name"
          v-if="form.exchange_mode==1"
          :help="formErr.exchange_name"
          :validateStatus='!formErr.exchange_name||formErr.exchange_name==""?"":"error"'
      >
        <a-select v-model="form.exchange_name"    @change="exchangeName">
          <a-select-option :value="item.exchange_type" :key="item.exchange_type" v-for="item in seleList.exchange"  >
            {{item.exchange_name}}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
          ref="exchange_name"
          label="兑换类型"
          prop="exchange_name"
          :help="formErr.exchange_name"
          v-else
          :validateStatus='!formErr.exchange_name||formErr.exchange_name==""?"":"error"'
      >
        <a-input
            :maxLength=20
            v-model="form.exchange_name"
            @change="(e) => { formErr.exchange_name=''}"
            @blur="(e) => {  form.exchange_name = e.target.value.trim();}"
        />
      </a-form-model-item>
      <div  style="position: relative">
      <a-form-model-item
          ref="rule_left"
          label="兑换规则"
          prop="rule_left"
          :help="formErr.rule_left"
          :validateStatus='!formErr.rule_left||formErr.rule_left==""?"":"error"'
      >
        <a-input
            :maxLength=6
            :precision="0"
            style="width:40%"
            v-model="form.rule_left"
             placeholder="积分数"
            @change="(e) => { formErr.rule_left=''}"
            @blur="(e) => {  form.rule_left = e.target.value.trim();}"
        />
      </a-form-model-item>
        <span style="position: absolute;left:48%;top: 10px">积分/</span>
      <a-form-model-item
          ref="rule_right"
          label=""
          prop="rule_right"
          style="width:40%;position: absolute;top: 0;right:20px"
          :help="formErr.rule_right"
          :validateStatus='!formErr.rule_right||formErr.rule_right==""?"":"error"'
      >
        <a-input
            :maxLength="ruleRight"
            :precision="0"
            v-model="form.rule_right"
            :placeholder="form.exchange_mode==1?form.exchange_name==1?'天数':form.exchange_name==2?'字符数':'条数':'填写兑换数量及单位'"
            @change="(e) => { formErr.rule_right=''}"
            @blur="(e) => {  form.rule_right = e.target.value.trim();}"
        />
      </a-form-model-item>
        <span  v-if="form.exchange_mode==1" style="position:absolute;right: 80px;top: 10px">{{form.exchange_name==1?'天':form.exchange_name==2?'万':'条'}}</span>
      </div>
      <a-form-model-item
          ref="thumb"
          label="缩略图"
          prop="thumb"
          :extra="formErr.thumb"
          :validateStatus='!formErr.thumb||formErr.thumb==""?"":"error"'
      >
        <a-upload
            :action="this.$store.state.urlChang"
            :data="{type:1}"
            :file-list="fileList"
            :headers="headers"
            @change="(file)=>{handleChange(file)}"
            :before-upload="beforeUpload"
            @preview="handlePreview"
            list-type="picture-card"
            name="file"
        >
          <div v-if="fileList.length < 1">
            <a-icon type="plus"/>
            <div class="ant-upload-text">Upload</div>
          </div>
        </a-upload>
        <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
          <img :src="previewImage" alt="example" style="width: 100%"/>
        </a-modal>
        <p>图片比例：4:3，大小不超过2M</p>
      </a-form-model-item>
    </a-form-model>
    <div class="drawer-btn"  >

      <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
        确定
      </a-button>
      <a-button @click="onClose">
        取消
      </a-button>
    </div>
  </a-drawer></div>
</template>

<script>
import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
import moment from 'moment';
import API from "../api";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  name: "videoForm",
  // props: ["visible","title","editId"],
  props: {
    visible:{type: Boolean,},
    title:{type: String,},
    editId:{type: [String, Number],},

  },
  data() {
    return {
      ruleRight:4,
      contenta: "",
      headers: {Authorization: window.sessionStorage.getItem("signature")},
      seleList:[],
      fileList:[],
      previewVisible: false,
      previewImage: "",
      drawerConfig ,
      form: {
        exchange_mode:1,
        exchange_name:1,
        rule_left:"",
        rule_right:"",
        thumb:""
      },
      formErr: {
        exchange_mode:"",
        exchange_name:"",
        rule_left:"",
        rule_right:"",
        thumb:""
      },
      rules: {
        exchange_mode: [{required: true, message: "请选择兑换方式",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.exchange_mode)}  , trigger: "blur"  },],
        exchange_name: [{required: true, message: "请选择兑换类型",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.exchange_name)}  , trigger: "blur"  },],
        rule_left: [{required: true, message: "请输入积分数",  },{pattern:/^[1-9]\d*$/,message: "请输入正整数", trigger: "blur"  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.rule_left)}  , trigger: "blur"  },],
        rule_right:[{required: true, message: "请输入天数",  },{pattern:/^[1-9]\d*$/,message: "请输入正整数", trigger: "blur"  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.rule_right)}  , trigger: "blur"  },],
        thumb:[{required: true, message: "  ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.thumb)}  , trigger: "blur"  },],
      },
      layout: {
        labelCol: { span:4},
        wrapperCol: { span:16 },
      },
    };

  },
  watch:{
    editId: function (a, b) {
      if (a != "") {
        API.service.EDIT_DATA({id:a}).then(res => {
          let data=res.data.data.info
          this.form = data
          if (this.form.thumb == "") {
            this.fileList = []
          } else {
            this.fileList = [
              {uid: this.form.thumb,
                name: this.form.thumb,
                status: "done",
                url: this.form.thumb ? this.form.thumb : ""
              }
            ]
          }
          this.form.id=a
          this.form.exchange_mode=res.data.data.info.exchange_mode*1
          this.form.exchange_name= res.data.data.info.exchange_mode==1?res.data.data.info.exchange_type*1:res.data.data.info.exchange_name

              this.exchangeMode(this.form.exchange_mode,this.form.exchange_name)
          this.exchangeName(this.form.exchange_name,this.form.exchange_name)
          this.form.exchange_name= res.data.data.info.exchange_mode==1?res.data.data.info.exchange_type*1:res.data.data.info.exchange_name

          // let _that=this
          //
          // _that.form.exchange_name= res.data.data.info.exchange_mode==1?res.data.data.info.exchange_type*1:res.data.data.info.exchange_name
          //


        })
      } else {
        this.form.id = ''
      }
    }
  },
  mounted(){
    this.getFormData()
  },
  methods: {
    exchangeMode(val,name=""){

      if(val==1){
        this.form.exchange_name=1
        if(this.form.exchange_name==1){
          this.ruleRight=4
          this.form.rule_right=  this.form.rule_right.substring(0,4)
          this.rules.rule_right=[{required: true, message: "请输入天数",  },{pattern:/^\d{1,}$/,message: "请输入正整数", trigger: "blur"}, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.rule_right)}  , trigger: "blur"  },]
        }else{
          this.ruleRight=5
          this.form.rule_right=  this.form.rule_right.substring(0,5)
          this.rules.rule_right=[{required: true, message: "请输入字符数",  },{pattern:/^\d{1,}$/,message: "请输入正整数", trigger: "blur"  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.rule_right)}  , trigger: "blur"  },]
        }
        this.$refs.ruleForm.validateField('exchange_name', (contentError) => {
          if(!contentError){
            //当校验通过时，这里面写逻辑代码
            this.formErr.exchange_name=""
          }
        })
      }else{
        this.form.exchange_name=name||""
        this.ruleRight=10
        this.rules.rule_right=[{required: true, message: "请输入兑换数量及单位",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.rule_right)}  , trigger: "blur"  },]
        this.rules.exchange_name=[{required: true, message: "请输入兑换类型",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.exchange_name)}  , trigger: "blur"  },]
      }

    },
    exchangeName(val){
      if(val==1){
        this.ruleRight=4
        this.form.rule_right=  this.form.rule_right.substring(0,4)
        this.rules.rule_right=[{required: true, message: "请输入天数",  },{pattern:/^[1-9]\d*$/,message: "请输入正整数", trigger: "blur"}, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.rule_right)}  , trigger: "blur"  },]
      }else{
        this.ruleRight=5
        this.form.rule_right=  this.form.rule_right.substring(0,5)
        if(val==2){
          this.rules.rule_right=[{required: true, message: "请输入字符数",  },{pattern:/^[1-9]\d*$/,message: "请输入正整数", trigger: "blur"  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.rule_right)}  , trigger: "blur"  },]
        }else if(val==3||val==4){
          this.rules.rule_right=[{required: true, message: "请输入条数",  },{pattern:/^[1-9]\d*$/,message: "请输入正整数", trigger: "blur"  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.rule_right)}  , trigger: "blur"  },]
        }else{
          this.rules.rule_right=[{required: true, message: "请输入兑换数量及单位",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.rule_right)}  , trigger: "blur"  },]
        }
         }
    },
    getFormData(){
      API.service.ADD_DATA().then(res => {
        this.seleList={
          exchange_mode:res.data.data.exchange_mode,
          exchange:res.data.data.exchange,
        }
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleChange(info ) {
      let {fileList} = info;
      const status = info.file.status;

      if (status !== 'uploading') {
        this.fileList=[]
      }
      if (status === 'done') {
        this.formErr.thumb=""
        this.fileList= fileList
      } else if (status === 'error') {
      }
      if (status === 'uploading') {
        this.fileList= fileList
      }
      if (status=== 'done') {
        getBase64(info.file.originFileObj, imageUrl => {
          this.formErr.thumb=""
          this.fileList= fileList
        });
      }
      //重新设置state
      // this.setState( {fileList});
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('只能上传jpeg、jpg，png类型图片!');
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片必须小于 2MB!');
        return false
      }
      return new Promise(function (resolve,reject) {
        resolve(file)
      })
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    onClose() {
      this.$emit("changVisible", false);
      this.fileList=[]
      this.form= {
        exchange_mode:1,
        exchange_name:1,
        rule_left:"",
        rule_right:"",
        thumb:""
      },
          this.formErr={
            exchange_mode:'',
            exchange_name:'',
            rule_left:"",
            rule_right:"",
            thumb:""
          },
          this.$refs.ruleForm.resetFields();
    },
    onSubmit() {
      let _this = this;
      let checks
      if (this.fileList.length < 1) {
          _this.formErr.thumb = "请上传缩略图";
        // return
      } else {
        _this.formErr.thumb = "";
        this.form.thumb = this.fileList[0].url
      }
      if (this.fileList.length > 0 && this.fileList[0].url) {
        this.form.thumb = this.fileList[0].url
      } else if (this.fileList.length > 0 && this.fileList[0].response) {
        this.form.thumb = this.fileList[0].response.data.url
      } else {
        this.form.thumb = ""
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if(checks==false)return
          let url
          let subData=JSON.parse(JSON.stringify(this.form))
           subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT

          if(subData.exchange_mode==1) {
            let exchange_name_val
            subData.exchange_type=subData.exchange_name
            console.log('this.seleList',this.seleList.exchange)
            this.seleList.exchange.map((item)=>{
              if(item.exchange_type==subData.exchange_name)exchange_name_val= item.exchange_name
            })
            subData.exchange_name=exchange_name_val

            // if(subData.exchange_name==1){
            //   subData.exchange_name="服务器"
            // }else{
            //   subData.exchange_name="翻译字符"
            // }
          }else{
            subData.exchange_type=99
          }

          submitForm(url, subData).then(res => {
            if (res == true) {
              this.onClose()
            } else {
              res.map((item, index) => {
                this.formErr[item.field] = item.msg
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
}
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.box >>> .ant-form-extra{top:calc(100% - 30px) !important;position: absolute}
.box >>> .ant-form-item-control-wrapper{position: relative}
</style>
